export default {
	type: 'object',
	properties: {
		flairColor: { type: 'string' },
		overlayText: { type: 'string' },
	},
	required: [],
	additionalProperties: false,
}
